import { useMutation } from "@tanstack/react-query";

import {
  paymentsService,
  type PaymentsExportParams,
} from "@/services/paymentsService";

export function useExportPayments() {
  return useMutation<void, Error, PaymentsExportParams>({
    mutationFn: (params) => paymentsService.exportPayments(params),
  });
}
